const breadcrumbObj = {
  home: '',
  ui: '',
  admin: 'Kezdőlap',
  dashboard: 'Dashboard',
  'dashboard/uzenetek': 'Üzenetek',
  uzenetek: 'Üzenetek',
  esemenyek: 'Események',
  eloadasok: 'Előadások',
  'eloadasok/felvitel': 'Előadás felvitel',
  'eloadasok/modositas': 'Előadás módosítás',
  musorok: 'Műsorok',
  'musorok/felvetel': 'Műsor felvitel',
  'musorok/modositas': 'Műsor módosítás',
  jegytipusok: 'Jegytípusok',
  jegyertekesites: 'Jegyértékesítés',
  helysziniertekesites: 'Helyszíni értékesítés',
  publikusertekesites: 'Jegyvásárlás',
  'jegyertekesites/lekerdezesek': 'Lekérdezések',
  'jegyertekesites/emailsablonok': 'Email sablonok',
  teremberles: 'Terembérlés',
  jegyellenorzes: 'Jegyellenőrzés',
  keszlet: 'Készlet',
  keszletkezeles: 'Készletkezelés',
  'bevetelezes/felvetel': 'Új készletnövekedés',
  'bevetelezes/modositas': 'Készletnövekedés módosítása',
  'csokkenes/felvetel': 'Új készletcsökkenés',
  'csokkenes/modositas': 'Készletcsökkenés módosítása',
  'selejtezes/felvetel': 'Új készletselejtezés',
  'selejtezes/modositas': 'Készletselejtezés módosítása',
  'leltar/felvetel': 'Új leltár',
  'leltar/modositas': 'Leltár módosítása',
  keszletinformacio: 'Készletinformáció',
  // raktarlista: 'Raktárkészlet lista',
  bufe: 'Büfé',
  ertekesites: 'Értékesítés',
  termekek: 'Termékek',
  forgalom: 'Forgalom',
  eladasilista: 'Eladási lista',
  rendelesek: 'Rendelések',
  rendeles: 'Rendelés',
  'szallitoi/felvetel': 'Új szállítói rendelés',
  'szallitoi/modositas': 'Szállítói rendelés módosítás',
  'ajanlat/felvetel': 'Új vevői ajánlat',
  'ajanlat/modositas': 'Vevői ajánlat módosítás',
  email: 'Email',
  munkalap: 'Munkalap',
  'munkalap/megtekintes': 'Munkalap megtekintés',
  'munkalap/felvetel': 'Munkalap felvitel',
  'munkalap/modositas': 'Munkalap módosítás',
  karbantartas: 'Karbantartás',
  feladatlista: 'Feladatlista',
  'feladatlista/felvetel': 'Feladat felvitel',
  'feladatlista/modositas': 'Feladat módosítás',
  'feladatlista/masolas': 'Feladat másolás',
  kedvezmeny: 'Kedvezmény',
  ugyfelszolgalat: 'Ügyfélszolgálat',
  'ugyfelszolgalat/esetek': 'Esetek',
  'ugyfelszolgalat/felvitel': 'Ügyfélszolgálat felvitel',
  'ugyfelszolgalat/modositas': 'Ügyfélszolgálat módosítás',
  'ugyfelszolgalat/szerkesztes': 'Ügyfélszolgálat szerkesztés',
  hirlevelkezeles: 'Hírlevélkezelés',
  blog: 'Blog',
  partner: 'Partner',
  partnertorzs: 'Partner törzs',
  'partnertorzs/felvitel': 'Partner felvitel',
  'partnertorzs/modositas': 'Partner módosítás',
  gdpd: 'GDPR',
  gdpr_beallitasok: 'GDPR beállítások',
  torzsadatok: 'Törzsadatok',
  cikk: 'Cikk',
  foldrajziegyseg: 'Földrajzi egységek',
  raktar: 'Raktár',
  bizonylatkezeles: 'Bizonylatkezelés',
  penzugy: 'Pénzügyi adatok',
  helyszin: 'Helyszín',
  'helyszin/felvitel': 'Helyszín felvitel',
  'helyszin/modositas': 'Helyszín módosítás',
  szemelyitorzs: 'Személyi törzs',
  cegadatok: 'Cégadatok',
  'cegadatok/felvetel': 'Cégadat felvitel',
  'cegadatok/modositas': 'Cégadat módosítás',
  felhasznalok: 'Felhasználók',
  'felhasznalo/felvetel': 'Felhasználó felvitel',
  'felhasznalo/modositas': 'Felhasználó módosítás',
  'csoport/felvetel': 'Csoport felvitel',
  'csoport/modositas': 'Csoport módosítás',
  idopontfoglalo: 'Időpontfoglaló',
  weboldalak: 'Weboldalak',
  bufekinalat: 'Büfé kínálat',
  tevekenysegek: 'Tevékenységek',
  promociok: 'Promóciók',
  extra: 'Extra tartalom',
  'idopont/lekerdezes': 'Lekérdezés',
  szamlazas: 'Számlázás',
  nyugta: 'Nyugták'
};

export default function getBreadcrumb(name) {
  return breadcrumbObj[name.toLowerCase()];
}
